import config from '@epi-config';

export const USER_API_URL = `${config.apiHost}/api/user`;
export const IMPERSONATION_API_URL = `${config.apiHost}/api/admin-tool/impersonation/token`;
